export default __webpack_public_path__ + "static/media/gallery03.b2d50180.png";